module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C98"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C106"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_ACKNOWLEDGMENTS#page_ix"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C103"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1__Breaking_the_Covenant#page_1"
    }
  }, [_vm._v("1. Breaking the Covenant")])]), _vm._v(" "), _c('p', {
    staticClass: "C103"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__Print_Media#page_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Print Media")])]), _vm._v(" "), _c('p', {
    staticClass: "C103"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3__Arts_and_Popular_Culture#page_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Arts and Popular Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "C103"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4__Television_Coverage#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Television Coverage")])]), _vm._v(" "), _c('p', {
    staticClass: "C106"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Conclusion#page_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "C103"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_NOTES#page_149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "C103"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_BIBLIOGRAPHY#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "C103"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_ABOUT_THE_AUTHOR_AND_SERIES_EDIT#page_165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR AND SERIES EDITOR")])]), _vm._v(" "), _c('p', {
    staticClass: "C103"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_INDEX#page_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 72
// module chunks = 0